import { getLocalizedMessage, showMessageAlert } from '@/core/shared'
import { initDataInBoolean } from '@/core/item_assistance/initializeComponentData'

export function getResourceFileLink (resourceName, global) {
	var name, prefix
	var xsltNameParts = resourceName.split('/')
	if (xsltNameParts[0] === 'global') {
		prefix = 'global'
		name = xsltNameParts[1]
	} else if (global) {
		prefix = 'global'
		name = resourceName
	} else {
		prefix = 'company'
		name = resourceName
	}

	var type
	var position = resourceName.lastIndexOf('.')
	var extension = resourceName.substring(position + 1)
	if (extension === 'xsl') {
		type = 'xslt'
	} else if (extension === 'xlsx' || extension === 'xls') {
		type = 'excel'
	} else if (extension === 'jpg' || extension === 'png' || extension === 'jpeg') {
		type = 'image'
	} else if (extension === 'xml') {
		type = 'xml'
	} else if (extension === 'csv') {
		type = 'csv'
	} else if (extension === 'zip') {
		type = 'zip'
	} else {
		console.error('Unknown resource extension: ' + extension)
	}

	var url = '/' + prefix + '/migration-resources/' + type + '?name=' + escape(resourceName)
	return {
		url: url,
		name: name
	}
}

export function uploadResourceFile (global, file, postAction) {
	var prefix = global ? 'global' : 'company'
	var url = window.urlContext + prefix + '/migration-resources/create'

	var data = new FormData()
	data.append('source', file)

	$.ajax({
		url: url,
		data: data,
		cache: false,
		contentType: false,
		processData: false,
		type: 'POST',
		async: false,

		success: function (data) {
			if (postAction) {
				postAction(data[0])
			}
		},

		error: function () {
			showMessageAlert(getLocalizedMessage("error"), getLocalizedMessage('error.loading.file'), 'danger');
		}
	})
}

export function loadResourceFiles (listSelector, type, global, company, select) {
	var url = window.urlContext + 'migration-resources/' + type + '/list'
	$.ajax({
		url: url,
		data: {
			global: global,
			company: company
		},
		cache: false,
		type: 'GET',
		success: function (data) {
			setResourceFilesList(listSelector, data, type)
			if (select) {
				listSelector.val(select)
			}
		},
		error: function () {
			showMessageAlert(getLocalizedMessage("error"), getLocalizedMessage('error.loading.resource.file.list'), 'danger');
		}
	})
}

function setResourceFilesList (listSelector, resourceFiles, type) {
	listSelector.empty()

	var resourceHtmlList = '<option></option>'
	if (!_.isEmpty(resourceFiles['company'])) {
		resourceHtmlList += '<optgroup label=\'' + getLocalizedMessage('company.' + type) + '\'>'
		_.each(resourceFiles['company'], function (xslt) {
			resourceHtmlList += '<option value=\'' + xslt + '\'>' + xslt + '</option>'
		})
		resourceHtmlList += '</optgroup>'
	}
	if (!_.isEmpty(resourceFiles['global'])) {
		resourceHtmlList += '<optgroup label=\'' + getLocalizedMessage('global.' + type) + '\'>'
		_.each(resourceFiles['global'], function (xslt) {
			resourceHtmlList += '<option value=\'global/' + xslt + '\'>' + xslt + '</option>'
		})
		resourceHtmlList += '</optgroup>'
	}

	listSelector.append(resourceHtmlList)
}

export function clearAllEditMigrationControls () {
	$('#transformation-type').removeAttr('disabled')
	$('#transformation-type').removeClass('def-val')

	$('#string-value-1').attr('placeholder', '')
	$('#string-value-2').attr('placeholder', '')

	$('#excel-template-link').remove()
	initDataInBoolean('debug-mode', false)
	initDataInBoolean('required-fields-only', false)
	initDataInBoolean('left-attribute-names', false)

	$('#migration-name').val('')
	$('#transformation-type').empty()
	$('#xslt-file').val('')
	$('#excel-template').val('')
	$('#string-value-1').val('')
	$('#string-value-2').val('')
	$('#csv-format-list').val('default')
	$('#import-sample').val('')
	$('#transformation-tag').val('')
	$('#migration-action').val('CREATE_AND_UPDATE')

	$('.file-input_excelTemplate').css('display', 'none')
	$('.file-input_importSample').css('display', 'none')
	$('.excel-template-sample').css('display', 'none')
	$('.xslt-file_select').css('display', 'none')
	$('.string-value_1').css('display', 'none')
	$('.string-value_2').css('display', 'none')
	$('.csv-format-list').css('display', 'none')
	$('#migration-parameters').css('display', 'none')
}

export function hideAllNewMigrationParameters () {
	$('#xslt-file').val('')
	$('#excel-template').val('')
	$('#string-value-1').val('')
	$('#string-value-2').val('')
	$('#csv-format-list').val('default')
	$('#import-sample').val('')

	$('#string-value-1').attr('placeholder', '')
	$('#string-value-2').attr('placeholder', '')

	$('.file-input_excelTemplate').css('display', 'none')
	$('.file-input_importSample').css('display', 'none')
	$('.excel-template-sample').css('display', 'none')
	$('.xslt-file_select').css('display', 'none')
	$('.string-value_1').css('display', 'none')
	$('.string-value_2').css('display', 'none')
	$('.csv-format-list').css('display', 'none')
	$('#migration-parameters').css('display', 'none')

	$('#migration-debug-mode').css('display', 'none')
	$('#migration-required-fields-only').css('display', 'none')
	$('#migration-left-attribute-names').css('display', 'none')
	initDataInBoolean('debug-mode', false)
	initDataInBoolean('required-fields-only', false)
	initDataInBoolean('left-attribute-names', false);
}
